import React from "react";
import { MapContainer, TileLayer, Circle } from "react-leaflet";
import "leaflet/dist/leaflet.css";

interface ApproximateMapProps {
  id: number;
  lat: number;
  lng: number;
}

export default function ApproximateMap({ id, lat, lng }: ApproximateMapProps) {
  const seed = id * 9301 + 49297;
  // ~200–400m offset so the circle doesn't center on the exact address
  const offsetLat = ((seed % 201) - 100) / 30000;
  const offsetLng = (((seed * 31 + 7) % 201) - 100) / 30000;
  const centerLat = lat + offsetLat;
  const centerLng = lng + offsetLng;

  return (
    <MapContainer
      center={[centerLat, centerLng]}
      zoom={13}
      scrollWheelZoom={false}
      dragging={false}
      doubleClickZoom={false}
      zoomControl={false}
      touchZoom={false}
      style={{ height: 400, width: "100%", borderRadius: 12, border: "1px solid #d1d5db" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Circle
        center={[centerLat, centerLng]}
        radius={300}
        pathOptions={{ color: "#2563eb", fillColor: "#2563eb", fillOpacity: 0.18, weight: 1 }}
      />
    </MapContainer>
  );
}
